<script>
import moment from 'moment'

import { ActionBar, ActionBarTitle } from '@/components/ui/action-bar'
import { PageContainer } from '@/components/page/page-container'
import { AppContainer } from '@/components/ui/container'
import { BuyProductService, WarehouseService } from '@/services'

import Overview from './Overview'
import Result from './Result'
import { back } from '@/utils/navigation'

export default {
  data() {
    const { query } = this.$route

    return {
      product: {
        name: ''
      },
      overview: {
        amount: 0,
        importAmount: 0,
        exportAmount: 0,
        isLoading: false
      },
      filter: {
        start: query.start ? new Date(query.start) : null,
        end: query.end ? new Date(query.end) : null
      },
      result: {
        items: [],
        pagination: {
          page: Number(query.page) || 1,
          total: 0,
          pageSize: 10
        },
        isLoading: false
      }
    }
  },

  created() {
    this.fetchProduct()
    this.fetchOverview()
    this.fetchResult()
  },

  methods: {
    async fetchProduct() {
      try {
        const {
          data: { result }
        } = await BuyProductService.get(this.$route.params.productId)

        this.product = {
          name: result.name
        }
      } catch (e) {
        this.$notify.error(e.message)
      }
    },

    async fetchOverview() {
      this.overview.isLoading = true

      try {
        const {
          data: { result }
        } = await WarehouseService.pawn.transaction.getOverview(
          this.$route.params.id,
          {
            datetime_after: this.filter.start
              ? this.filter.start.toISOString()
              : undefined,
            datetime_before: this.filter.end
              ? this.filter.end.toISOString()
              : undefined
          }
        )

        this.overview = {
          ...this.overview,
          amount: +result.remaining_amount,
          importAmount: +result.in_amount,
          exportAmount: +result.out_amount
        }
      } catch (e) {
        this.$notify.error(e.message)
      } finally {
        this.overview.isLoading = false
      }
    },

    async fetchResult() {
      this.result.isLoading = true

      try {
        const {
          data: { result }
        } = await WarehouseService.pawn.transaction.getAll(
          this.$route.params.id,
          {
            datetime_after: this.filter.start
              ? this.filter.start.toISOString()
              : undefined,
            datetime_before: this.filter.end
              ? this.filter.end.toISOString()
              : undefined,
            page: this.result.pagination.page
          }
        )

        const { results, count } = result

        this.result.items = results.map(item => ({
          id: item.id,
          date: new Date(item.datetime),
          ticketNo: item.pawn_pos_insurance_number,
          type: item.action_type_name,
          amount: +item.amount,
          left: +item.remaining_amount,
          refId: item.ref_id
        }))

        this.result.pagination = { ...this.result.pagination, total: count }
      } catch (e) {
        this.$notify.error(e.message)
      } finally {
        this.result.isLoading = false
      }
    },

    dismiss() {
      back({ name: 'WarehousePawn' })
    },

    handleOverviewPeriodSubmit() {
      const replaceRouter = () => {
        const start = moment(this.filter.start)
        const end = moment(this.filter.end)

        const query = {
          start: start.isValid() ? start.format('Y-MM-DD') : undefined,
          end: end.isValid() ? end.format('Y-MM-DD') : undefined
        }

        this.$router.replace({ query })
      }

      replaceRouter()

      this.result.pagination = { ...this.result.pagination, page: 1 }

      this.fetchOverview()
      this.fetchResult()
    },

    handleResultPageChange(page) {
      this.result.pagination = { ...this.result.pagination, page }

      this.$router.replace({ query: { ...this.$route.query, page } })

      this.fetchResult()
    },

    handleResultView(id) {
      this.$router.push({ name: 'PawnDetail', params: { id } })
    }
  },

  render() {
    return (
      <div>
        <ActionBar dismissible onDismiss={this.dismiss}>
          <ActionBarTitle>
            คลังสินค้า ทองขายฝาก / {this.product.name}
          </ActionBarTitle>
        </ActionBar>
        <PageContainer>
          <AppContainer>
            <Overview
              name={this.product.name}
              amount={this.overview.amount}
              importAmount={this.overview.importAmount}
              exportAmount={this.overview.exportAmount}
              start={this.filter.start}
              end={this.filter.end}
              loading={this.overview.isLoading}
              on={{
                'update:start': value => {
                  this.filter.start = value
                },
                'update:end': value => {
                  this.filter.end = value
                },
                submit: this.handleOverviewPeriodSubmit
              }}
            />
            <Result
              items={this.result.items}
              pagination={this.result.pagination}
              loading={this.result.isLoading}
              style={{ marginTop: '1.5rem' }}
              onPageChange={this.handleResultPageChange}
              onView={this.handleResultView}
            />
          </AppContainer>
        </PageContainer>
      </div>
    )
  }
}
</script>
